// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header {\r\n    background-color:rgb(227,66,52);\r\n    padding: 15px;\r\n    color: white;\r\n    text-align: center;\r\n}\r\n\r\n.logo {\r\n    height: 80px;\r\n}\r\n  \r\n.title {\r\n    font-size: 1.5em;\r\n}", ""]);
// Exports
module.exports = exports;
